/** Route paths owned by the onboarding flow. */
export const ONBOARDING_PATHS = {
  root: '/onboarding',
  verification: '/onboarding/verification',
  wizard: '/onboarding/wizard',
} as const;
